import React, { useState } from "react";
import { Form, Input, Button } from "antd";
import { useTranslation } from "react-i18next";
import { RiLockPasswordLine } from "react-icons/ri";
import { useNavigate, useParams } from "react-router-dom";
import { showNotitfication } from "../../utils/Utils";
import ReactPasswordChecklist from "react-password-checklist";
import Navbar from "../Menu/Navbar";
import Footer from "./Sections/Footer";
import { useSearchParams } from "react-router-dom";
import { toResetPasswordValidate } from "../../apis/actions/auth.actions";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../apis/store";

const ResetPassword = () => {
  const { t, i18n } = useTranslation();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [password, setPassword] = useState<string>("");
  const [passwordAgain, setPasswordAgain] = useState<string>("");
  const [isValid, setIsValid] = useState<boolean>(false);
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const token = searchParams.get("id");
  const dispatch = useDispatch<AppDispatch>();

  const onFinish = async () => {
    setLoading(true);
    try {
      await form.validateFields();
      const values = form.getFieldsValue();
      const applyData = {
        ...values,
        token: token,
      };
      const success = (await dispatch(
        toResetPasswordValidate(applyData)
      )) as any;
      const RequestReset_password = success?.payload?.data?.result;

      if (RequestReset_password?.code === 200) {
        showNotitfication(
          i18n.language === "ar"
            ? "تم إعادة تعيين كلمة المرور بنجاح. يمكنك الآن تسجيل الدخول بكلمة المرور الجديدة."
            : "Your password has been reset successfully. You can now log in with your new password.",
          "success"
        );

        setTimeout(() => {
          navigate("/login");
        }, 2800);
        setLoading(false);
      } else {
        showNotitfication(
          i18n.language === "ar"
            ? "عذرًا، حدث خطأ أثناء تغيير كلمة المرور. يُرجى المحاولة مرة أخرى لاحقًا."
            : "Sorry, an error occurred while changing the password. Please try again later.",
          "error"
        );
        setLoading(false);
      }
    } catch (error) {}
  };

  return (
    <>
      <Navbar type="internal" />
      <main className="main">
        <div className="container pt-40 pb-170">
          <div className="row">
            <div className="col-lg-5 mx-auto">
              <div className="reset-password-content border rounded-3 px-md-5 px-3 ptb-50">
                <div className="text-center">
                  <p className="text-white px-4 py-2 ac--font-expo ac--background-primary text-sm-bold rounded-12 d-inline-flex align-items-center">
                    {t("resetPassword.resetPassword")}
                  </p>
                  <h4 className="neutral-1000 ac--font-expo mt-4">
                    {t("resetPassword.createNewPassword")}
                  </h4>
                </div>
                <div className="form-reset-password mt-30">
                  <Form form={form} onFinish={onFinish}>
                    {/* Password Field */}
                    <Form.Item
                      name="password"
                      rules={[
                        {
                          required: true,
                          message: t("resetPassword.messages.passwordRequired"),
                        },
                      ]}
                    >
                      <div className="form-group ac--password-container">
                        <Input.Password
                          className="ac--input-login"
                          size="large"
                          placeholder={t("resetPassword.placeholder.password")}
                          prefix={<RiLockPasswordLine size={17} />}
                          onChange={(e) => setPassword(e.target.value)}
                        />
                      </div>
                    </Form.Item>

                    {/* Confirm Password Field */}
                    <Form.Item
                      rules={[
                        {
                          required: true,
                          message: t(
                            "resetPassword.messages.confirmPasswordRequired"
                          ),
                        },
                      ]}
                    >
                      <div className="form-group">
                        <Input.Password
                          className="ac--input-login"
                          size="large"
                          placeholder={t(
                            "resetPassword.placeholder.confirmPassword"
                          )}
                          onChange={(e) => setPasswordAgain(e.target.value)}
                          prefix={<RiLockPasswordLine size={17} />}
                        />
                      </div>
                    </Form.Item>

                    {/* Password Validation Checklist */}
                    <ReactPasswordChecklist
                      rules={["minLength", "number", "capital", "match"]}
                      minLength={6}
                      value={password}
                      className="ac--font-expo"
                      valueAgain={passwordAgain}
                      onChange={(isValid) => {
                        setIsValid(isValid);
                      }}
                      messages={{
                        minLength: t("authentication.message.message1"),
                        number: t("authentication.message.message2"),
                        capital: t("authentication.message.message3"),
                        match: t("authentication.message.message4"),
                      }}
                    />

                    {/* Submit Button */}
                    <div className="form-group mb-30 mt-20">
                      <Button
                        type="primary"
                        htmlType="submit"
                        className="btn btn-primary w-100 h-100"
                        disabled={!isValid || loading}
                        loading={loading}
                      >
                        {t("resetPassword.resetPasswordButton")}
                      </Button>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer type="external" />
    </>
  );
};

export default ResetPassword;
